/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-add-alt': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 2.5a7.5 7.5 0 110 15 7.5 7.5 0 010-15zm0-1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zm3.75 8.125h-3.125V6.25h-1.25v3.125H6.25v1.25h3.125v3.125h1.25v-3.125h3.125v-1.25z"/>'
  }
})
